import { SVGProps, Ref, forwardRef } from "react";

const DotIcon = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="6"
    height="6"
    viewBox="0 0 6 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <circle cx="3" cy="3" r="3" fill="currentColor" />
  </svg>
);

const ForwardRef = forwardRef(DotIcon);
export default ForwardRef;
